document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".scrollspy-menu").forEach((nav) => {
        const navLinks = nav.querySelectorAll(".nav-link");
        const container = nav.closest(".container-fluid");
        const sections = container.querySelectorAll("section");

        if (sections.length === 0) {
            console.warn("⚠️ No sections found inside", container);
            return;
        }

        function updateActiveNav() {
            let activeSection = null;

            // Determine which section is in view
            sections.forEach((section) => {
                const rect = section.getBoundingClientRect();
                if (rect.top <= 100 && rect.bottom > 100) {
                    activeSection = section;
                }
            });

            // Remove 'active' class from all nav links
            navLinks.forEach((link) => link.classList.remove("active"));

            // Add 'active' class to the correct nav link
            if (activeSection) {
                const activeLink = nav.querySelector(`.nav-link[href="#${CSS.escape(activeSection.id)}"]`);
                if (activeLink) {
                    activeLink.classList.add("active");
                }
            }
        }

        // Add event listener for scrolling
        window.addEventListener("scroll", updateActiveNav);

        // Run the function on page load to set initial state
        updateActiveNav();
    });
});